import { render, staticRenderFns } from "./Businessfee.vue?vue&type=template&id=54d7af72&"
import script from "./Businessfee.vue?vue&type=script&lang=js&"
export * from "./Businessfee.vue?vue&type=script&lang=js&"
import style0 from "./Businessfee.vue?vue&type=style&index=0&id=54d7af72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports